import React, { useEffect, useContext } from 'react'
import styled from 'styled-components'
import gsap from 'gsap'
import { Background, EventsContainerView, EventView, MenuTitle, MenuView } from './SavedMenu'
import { SavedTripsContext } from '../utils/savedTripsContext'
import activities from '../data/activities'
import t from '../data/en_new.json'
import { Arrow } from './MainEventMenu'

const Close = styled.div`
  display: none;
  position: absolute;
  top: 19px;
  right: 19.3%;
  color: #fff;
  font-size: 12px;
  font-family: 'Sica', sans-serif;
  cursor: pointer;

  @media screen and (min-width: 768px) {
    display: flex;
  }
`

const SavedEventMenu = ({ isOpen, closeMenu }) => {
  const { savedTrips, setSavedTrips } = useContext(SavedTripsContext)

  useEffect(() => {
    if(isOpen) {
      gsap.set('.savedEventsMenu', {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      })

      gsap.to('.savedEventsMenu', {
        duration: .5,
        delay: .15,
        opacity: 1,
        ease: 'power3.inOut',
      })

      gsap.to('.savedEventsMenubackground', {
        duration: .5,
        top: 0,
        left: 0,
        ease: 'power3.inOut',
      })
    } else {
      gsap.to('.savedEventsMenubackground', {
        duration: .5,
        left: '100%',
        top: '100vh',
        ease: 'power3.inOut',
      })

      gsap.to('.savedEventsMenu', {
        duration: .2,
        opacity: 0,
        ease: 'power3.inOut',
        onComplete: () => gsap.set('.savedEventsMenu', {
          left: '100%',
          top: '100vh',
          right: 0,
          bottom: '100%',
        }),
      })
    }
  }, [isOpen])

  const upHandler = ({ key }) => {
    if(key === 'Escape') {
      closeMenu()
    }
  }

  useEffect(() => {
    window.addEventListener("keyup", upHandler)
    return () => {
      window.removeEventListener("keyup", upHandler)
    };
  }, [])

  const removeActivty = (id) => {
    setSavedTrips(savedTrips.filter(trip => trip !== id))
  }

  return (
    <>
      <Background className='savedEventsMenubackground'/>
      <MenuView className='savedEventsMenu'>
        <Close onClick={closeMenu}>
          <div>CLOSE</div>
          <Arrow width='10px' height='10px' transform='transform: rotate(90deg);'/>
        </Close>
        <EventsContainerView>
          <MenuTitle>{t.menu.your_choices}:</MenuTitle>
          {savedTrips.map(trip => (
            <EventView
              key={`saved-menu-${trip}`}
              removeActivty={removeActivty}
              {...activities.find(activity => activity.id === trip)}
            />
          ))}
        </EventsContainerView>
      </MenuView>
    </>
  )
}

export default SavedEventMenu